import Model from "../Model";

class KpiclientrepresentantUser2 extends Model{

    buildUrl ({ param }) {
        return ['kpiemployeeclientview/infobyuserid', param];
    }

    all(config = {}) {
        return this.request({ method: 'POST', action: 'all', ...config });
    }
}


export default new KpiclientrepresentantUser2;